import React from "react";
import cx from "clsx";
import { buildURL } from "../../../../marketplace-next/src/utils/image/cloudinary";
import { IMAGE_SIZE, IMAGE_MODS } from "./constants";
export var CtaImage = function (_a) {
    var _b, _c;
    var className = _a.className, image = _a.image;
    var imageUrl = (_b = image === null || image === void 0 ? void 0 : image.url) !== null && _b !== void 0 ? _b : "";
    var imageAlt = (_c = image === null || image === void 0 ? void 0 : image.alt) !== null && _c !== void 0 ? _c : "";
    return (React.createElement("img", { src: buildURL(imageUrl, IMAGE_MODS), alt: imageAlt, className: cx("md:-mt-1", className), width: IMAGE_SIZE, height: IMAGE_SIZE, loading: "eager" }));
};
//# sourceMappingURL=CtaImage.js.map